import useStateRef from "react-usestateref";
import { useEffect } from "react";
import { CreatorNodesStore } from "../store/CreatorNodesStore";
import { getIt } from "@uikit/getIt";

const creatorNodesStore = getIt(CreatorNodesStore);

export function useCreatorNodeState() {
  const [nodes, setNodes] = useStateRef(creatorNodesStore.state.nodes);

  useEffect(() => {
    function subscription(val: typeof creatorNodesStore.state) {
      // if (!val.nodes.length) {
      //   console.trace("empty");
      // }
      setNodes(val.nodes);
    }

    const sub = creatorNodesStore.on(subscription, true);
    return () => {
      sub.off();
    };
  }, []);

  return { nodes };
}
